import { TrendCurlUpIcon, TrendDownIcon, TrendUpIcon, WalletIcon } from "./DashboardIcons";

import { DashboardCard } from "./DashboardCard";
import { PayrollClearingAccountData } from "../dashboardOverview.types";
import { formatCurrency } from "../dashboardFormat.utils";

export interface PayrollClearingAccountCardProps {
	data: PayrollClearingAccountData;
	onViewLedger?: () => void;
}

export const PayrollClearingAccountCard = ({ data, onViewLedger }: PayrollClearingAccountCardProps) => {
	return (
		<DashboardCard testId="payroll-clearing-account-card">
			<div className="cd-card__header">
				<div className="cd-card__title">
					<h2>Account summary</h2>
				</div>
				<button type="button" className="cd-link-button" onClick={onViewLedger}>
					View ledger
				</button>
			</div>

			<div className="cd-clearing-balance">
				<div className="cd-clearing-balance__label">
					<span className="cd-clearing-balance__icon">
						<WalletIcon />
					</span>
					<span>Payroll clearing balance</span>
				</div>
				<div className="cd-clearing-balance__value">{formatCurrency(data.balance, data.currency)}</div>
			</div>

			{/* ===== CHANGED: red down-arrow icon before each debit row (copy this block) ===== */}
			<div className="cd-ledger-list">
				{data.ledgerItems.map((item) => (
					<div className="cd-ledger-list__row" key={item.id}>
						<span className="cd-ledger-list__label">
							{item.amount < 0 && <TrendDownIcon className="cd-icon--danger" />}
							{item.label}
						</span>
						<span className={item.amount < 0 ? "cd-ledger-list__amount--debit" : "cd-ledger-list__amount--credit"}>
							{item.amount < 0 ? "−" : "+"}
							{formatCurrency(Math.abs(item.amount), data.currency)}
						</span>
					</div>
				))}
			</div>

			<div className="cd-clearing-projected">
				<span>{data.projectedLabel}</span>
				<span className={data.projectedAmount < 0 ? "cd-clearing-projected__amount--negative" : ""}>
					{data.projectedAmount < 0 ? "−" : ""}
					{formatCurrency(Math.abs(data.projectedAmount), data.currency)}
				</span>
			</div>

			{/* ===== CHANGED: no icon on the shortfall banner (copy this block) ===== */}
			{data.shortfallNote && (
				<div className="cd-clearing-shortfall">
					<span>{data.shortfallNote}</span>
				</div>
			)}

			{/* ===== CHANGED: bordered two-up box with a trend icon per figure,
			    divider between the two halves (copy this block) ===== */}
			<div className="cd-clearing-ytd">
				<div className="cd-clearing-ytd__item">
					<span className="cd-clearing-ytd__label">
						<TrendCurlUpIcon />
						YTD gross
					</span>
					<span className="cd-clearing-ytd__value">{formatCurrency(data.ytdGross, data.currency)}</span>
				</div>
				<div className="cd-clearing-ytd__item">
					<span className="cd-clearing-ytd__label">
						<TrendUpIcon />
						YTD remitted
					</span>
					<span className="cd-clearing-ytd__value">{formatCurrency(data.ytdRemitted, data.currency)}</span>
				</div>
			</div>
		</DashboardCard>
	);
};